import i18next from 'i18next';

i18next.addResources('en', 'AdelphiStatementsSpiritAndFeints', {
  date: 'Date',
  receiver: 'Receiver',
  dip: 'Dip',
  bulk: 'Bulk',
  temp: 'Temp',
  density: 'Density',
  strength: 'STR %',
  tcf: 'T.C.F.',
  lalc: 'Lts/Alc',
  charge: 'Charge',
  filled: 'Filled',
  filledAndRemanent: 'Filled + Remanent',
  lossGain: 'Loss/Gain',
  nroFilled: 'No Filled',
  navBarTitle: 'Period: {{periodId}}',
  finalCalculations: 'View Final Calculations'
});
